import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-button-copy-field',
  templateUrl: './button-copy-field.component.html',
  styleUrls: ['./button-copy-field.component.scss'],
  standalone: false,
})
export class ButtonCopyFieldComponent {
  @Input() marketList: any;
  @Output() clicked = new EventEmitter();

  constructor() {}
}
